import {AppState} from '../store';

export const getCommonLoading = (state: AppState) => state.common.loading;

export const getCommonNotifications = (state: AppState) =>
  state.common.notifications;
